import { isEmpty } from 'lodash';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Dialog, Form, Loading, MessagePlugin } from 'tdesign-react';
import styled from 'styled-components';
import { fetchVariableStencil } from '@/slices/variableSlice';
import { updateVariableStencilVars } from '@/services/variableService';
import TipCmp from '@/components/Tip';
import VarInput, { convertDetailToProps } from '../../components/VarInput';

const { FormItem } = Form;

function VarsModal({ visible, handleClose, id, stencilVars, fetchVariableStencil, loading }) {
  const [submitting, setSubmitting] = useState(false);
  const [form] = Form.useForm();

  const handleSubmit = async ({ validateResult, fields }) => {
    if (validateResult === true) {
      try {
        setSubmitting(true);
        await updateVariableStencilVars({
          ...fields,
          stencilId: id,
        });
        MessagePlugin.success('操作成功');
        handleClose(true);
      } catch (error) {
        console.trace(error);
        throw error;
      } finally {
        setSubmitting(false);
      }
    }
  };

  useEffect(() => {
    if (visible) {
      fetchVariableStencil(id);
    } else {
      form.reset();
    }
  }, [visible, fetchVariableStencil, id, form]);

  useEffect(() => {
    if (!isEmpty(stencilVars)) {
      form.setFieldsValue({ valueList: stencilVars });
    }
  }, [stencilVars, form]);

  return (
    <Dialog
      header='调整变量'
      visible={visible}
      onClose={() => handleClose()}
      placement='center'
      confirmBtn={{ loading: submitting, content: '确定' }}
      onConfirm={() => form.submit()}
      width='90%'
    >
      <Loading loading={loading}>
        <Form layout='inline' labelWidth={160} labelAlign='top' form={form} onSubmit={handleSubmit}>
          {stencilVars.map((item, index) => (
            <React.Fragment key={item.id}>
              <FormItem name={['valueList', index, 'key']} style={{ display: 'none' }} />
              <FormItem
                name={['valueList', index, 'defaultValue']}
                label={
                  <Tip
                    content={item.dependKey ? `依赖 ${item.dependKey} = ${item.dependValue}` : null}
                  >
                    {item.key}
                  </Tip>
                }
                rules={[{ required: item.variableType === 1, message: `${item.key}必填` }]}
                style={{ width: '30%' }}
              >
                <VarInput type={item.showType} inputProps={convertDetailToProps(item.showDetail)} />
              </FormItem>
            </React.Fragment>
          ))}
        </Form>
      </Loading>
    </Dialog>
  );
}

export default connect(
  (state) => ({
    stencilVars: state.variable.stencilVars,
    loading: state.variable.loading,
  }),
  {
    fetchVariableStencil,
  },
)(VarsModal);

const Tip = styled(TipCmp)`
  white-space: initial;
  word-break: break-all;
  line-height: var(--td-comp-margin-l);
  padding-bottom: 8px;
`;
